import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Card, Col, Divider, Row, Space } from "antd";
import ConsignmentFreightItemForm, {} from "./ConsignmentFreightItemForm";
import ConsignmentFreightTable from "./ConsignmentFreightTable";
import { EditMode } from "../../enums/EditMode";
const ConsignmentFreightForm = ({ tenantId, freight, onChange, showWasteRecordId = true, showTrackingCode = true, showDescription = true }) => {
    const freightItemFormRef = useRef(null);
    const [mode, setMode] = useState(EditMode.CREATE);
    const [editingItem, setEditingItem] = useState(undefined);
    const [editingIndex, setEditingIndex] = useState(-1);
    const saveFormItem = () => {
        freightItemFormRef.current?.validateFields().then(formValues => {
            const updatedFreight = [...freight];
            const newFreightItem = {
                id: editingItem ? editingItem.id : 0,
                version: editingItem ? editingItem.version : 0,
                description: formValues.description,
                productId: formValues.productId,
                productReference: formValues.productReference,
                productDescription: formValues.productDescription,
                dimensionUnit: formValues.dimensionUnit,
                height: formValues.height,
                length: formValues.length,
                orderedQuantity: formValues.orderedQuantity,
                trackingCode: formValues.trackingCode,
                unitOfMeasure: formValues.unitOfMeasure,
                weight: formValues.weight,
                weightUnit: formValues.weightUnit,
                width: formValues.width,
                wasteRecordId: formValues.wasteRecordId
            };
            if (mode === EditMode.CREATE) {
                updatedFreight.push(newFreightItem);
            }
            if (mode === EditMode.EDIT && editingIndex >= 0) {
                updatedFreight[editingIndex] = newFreightItem;
            }
            setEditingItem(undefined);
            setEditingIndex(-1);
            setMode(EditMode.CREATE);
            freightItemFormRef.current?.resetFields();
            onChange(updatedFreight);
        }).catch(console.error); // This has to be present otherwise antd crashes :(
    };
    const addFreightItem = () => {
        saveFormItem();
    };
    const updateFreightItem = () => {
        saveFormItem();
    };
    const editFreightItem = (item, index) => {
        setEditingItem(item);
        setEditingIndex(index);
        setMode(EditMode.EDIT);
    };
    const removeFreightItem = (index) => {
        const updatedFreight = [...freight];
        updatedFreight.splice(index, 1);
        onChange(updatedFreight);
    };
    const cancel = () => {
        setEditingItem(undefined);
        setEditingIndex(-1);
        setMode(EditMode.CREATE);
        freightItemFormRef.current?.resetFields();
    };
    const determineTitle = () => {
        switch (mode) {
            case EditMode.CREATE:
                return 'Add Freight';
            case EditMode.EDIT:
                return 'Edit Freight';
        }
    };
    return (_jsxs(Row, { gutter: 10, children: [_jsx(Col, { lg: 24, xl: 10, children: _jsxs(Card, { title: determineTitle(), type: 'inner', variant: 'borderless', children: [_jsx(ConsignmentFreightItemForm, { ref: freightItemFormRef, showTrackingCode: showTrackingCode, showWasteRecordId: showWasteRecordId, showDescription: showDescription, editMode: 'EDIT_ALL', tenantId: tenantId, freightItem: editingItem }), _jsxs(Space, { children: [mode === EditMode.EDIT && _jsx(Button, { htmlType: "button", onClick: cancel, children: "Cancel" }), mode === EditMode.CREATE && _jsx(Button, { htmlType: "button", onClick: addFreightItem, type: "primary", children: "Add" }), mode === EditMode.EDIT && _jsx(Button, { htmlType: "button", onClick: updateFreightItem, type: "primary", children: "Update" })] })] }) }), _jsx(Col, { lg: 24, xl: 14, children: _jsx(Card, { title: 'Freight', type: 'inner', variant: 'borderless', children: _jsx(ConsignmentFreightTable, { showDescription: showDescription, showGrossTare: false, freight: freight, hasActions: true, renderActions: (text, record, index) => (_jsxs("span", { children: [_jsx(Button, { htmlType: "button", size: "small", onClick: () => editFreightItem(record, index), children: "Edit" }), _jsx(Divider, { orientation: "vertical" }), _jsx(Button, { htmlType: "button", size: "small", onClick: () => removeFreightItem(index), children: "Remove" })] })) }) }) })] }));
};
export default ConsignmentFreightForm;
